// RailCard.js — bordered right-rail card for supporting context: the version
// diff, the pre-send validation checklist, the GM-floor indicator (F-05), the
// Voice crossover card (F-06), port readiness (F-07). Optional eyebrow node —
// pass <AISparkle/> ONLY for genuinely-AI cards. Faithful port of
// components/workspace/RailCard.jsx.
import React from 'react';
import { v3 } from '../../lib/styleTokens';

export function RailCard({ title, eyebrow, children, style = {} }) {
  return (
    <div
      style={{
        background: v3.color.card,
        border: `1px solid ${v3.color.border}`,
        borderRadius: v3.radius.cardLarge,
        padding: 16,
        fontFamily: v3.font.family,
        ...style,
      }}
    >
      {title && (
        <div
          style={{
            fontSize: v3.font.size.micro,
            color: v3.color.muted,
            fontWeight: v3.font.weight.semibold,
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            marginBottom: 10,
            display: 'flex',
            alignItems: 'center',
            gap: 6,
          }}
        >
          {eyebrow}
          {title}
        </div>
      )}
      {children}
    </div>
  );
}
